import { cva } from 'class-variance-authority';
export var progressBarContainerVariants = cva('flex flex-col gap-1 mt-1', {
    defaultVariants: {
        size: 'default',
    },
    variants: {
        size: {
            default: '',
            large: 'md:mt-0',
        },
    },
});
export var progressBarVariants = cva('w-full bg-gray-200 rounded-full h-2 sm:h-3 overflow-hidden mt-[0.15rem]', {
    defaultVariants: {
        size: 'default',
    },
    variants: {
        size: {
            default: '',
            large: 'md:h-[1.25rem] md:mt-[0.5rem]',
        },
    },
});
export var progressBarTitleVariants = cva('font-bold text-neutral-900 text-xs sm:text-sm sm:text-base', {
    defaultVariants: {
        size: 'default',
    },
    variants: {
        size: {
            default: '',
            large: 'md:text-lg lg:text-xl',
        },
    },
});
export var progressBarTitleLabelVariants = cva('font-normal text-neutral-700 text-xs sm:text-sm', {
    defaultVariants: {
        size: 'default',
    },
    variants: {
        size: {
            default: '',
            large: 'lg:text-base',
        },
    },
});
